import React from "react";
import { Spinner } from "reactstrap";
import { Img } from "react-image";
import ImageNotFound from "./ImageNotFound";
import imagePlaceholder from "/@src/assets/img/placeholder/placeholder-image.png";

function ReactImage({
  alt = "an image",
  src,
  style,
  placeholder = imagePlaceholder,
  className = "",
}) {
  return (
    <Img
      src={[src || placeholder]}
      className={`${className}`}
      loader={
        <div className="d-flex justify-content-center align-items-center h-100">
          <Spinner color="primary" className="mb-1" />
        </div>
      }
      unloader={<ImageNotFound />}
      style={{ ...style }}
      alt={alt}
    />
  );
}

export default ReactImage;
